<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 14/1/2021
  -->
<script>

import ViewModeComponent from "@/core/components/ViewModeComponent.vue";

export default {
	name: "BaseDataComponent",
	extends: ViewModeComponent,
	props: {
		loadDataOnStart: {Boolean, default: true},
	},


	async mounted(){
		this.setup()
		if(this.loadDataOnStartComputed){
			await this.handleAsync(this.loadData())
		}
	},

	methods:{

		setup(){

		},

		async loadData(){

		}
	},

	computed:{
		loadDataOnStartComputed(){
			return this.loadDataOnStart
		}
	}
}
</script>

<style lang="scss">

</style>
